/* Guia de tamanhos — joalharia e chapelaria.
   Abre o painel, troca de separador, converte medidas em tamanhos, apaga os
   tamanhos que a peça não vende e carrega mesmo no tamanho na ficha. */
(function(){
  'use strict';
  var raiz=document.querySelector('[data-g]');
  var pag=document.querySelector('[data-g-pag]');
  var caixa=raiz||pag; if(!caixa) return;

  var T={};
  var cfg=document.querySelector('[data-g-cfg]');
  if(cfg) Array.prototype.forEach.call(cfg.attributes,function(a){
    if(a.name.indexOf('data-t-')===0) T[a.name.slice(7)]=a.value; });
  function txt(k,d){ return T[k]||d; }
  function num(v){ v=parseFloat(String(v==null?'':v).replace(',','.')); return isNaN(v)?null:v; }

  /* ---------- abrir / fechar ---------- */
  var ultimo=null, mudado=false;
  function aoCorpo(){           // tirar de dentro de qualquer ancestral com transform/sticky
    if(mudado||!raiz) return;
    if(raiz.parentNode!==document.body) document.body.appendChild(raiz);
    mudado=true;
  }
  function abrir(){ if(!raiz) return; aoCorpo(); ultimo=document.activeElement; raiz.hidden=false;
    document.documentElement.style.overflow='hidden'; marcar();
    var f=raiz.querySelector('.g__in'); if(f) f.focus({preventScroll:true}); }
  function fechar(){ if(!raiz) return; raiz.hidden=true; document.documentElement.style.overflow='';
    if(ultimo&&ultimo.focus) ultimo.focus(); }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-g-open]')){ e.preventDefault(); abrir(); }
    else if(e.target.closest('[data-g-close]')) fechar(); });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&raiz&&!raiz.hidden) fechar(); });

  /* ---------- separadores ---------- */
  caixa.addEventListener('click',function(e){
    var b=e.target.closest('[data-g-tab]'); if(!b) return;
    var alvo=b.getAttribute('data-g-tab');
    caixa.querySelectorAll('[data-g-tab]').forEach(function(x){x.classList.toggle('is-on',x===b);});
    caixa.querySelectorAll('[data-g-pane]').forEach(function(p){
      p.classList.toggle('is-on',p.getAttribute('data-g-pane')===alvo);});
  });

  /* ---------- o que esta peça vende ---------- */
  function normaliza(s){
    s=String(s==null?'':s).trim().replace(',','.');
    var u=s.match(/US\s*(\d+(?:\.\d+)?)/i);   // "N½ · US 7", "Maat 54 · US 7"
    if(u) return String(parseFloat(u[1]));
    var m=s.match(/\d+(\.\d+)?/);
    if(!m) return s.toUpperCase();
    var n=parseFloat(m[0]);
    if(/½|1\/2/.test(s)&&s.indexOf('.')<0) n+=0.5;
    return String(n);
  }
  // "Regular · 55–58 cm" -> {a:55,b:58}   "Adjustable (US5-7)" -> {a:5,b:7}
  function amplitude(s){
    var m=String(s==null?'':s).replace(',','.')
          .match(/(\d{1,2}(?:\.\d)?)\s*[–—-]\s*(\d{1,2}(?:\.\d)?)/);
    if(!m) return null;
    var a=parseFloat(m[1]), b=parseFloat(m[2]);
    return b>a?{a:a,b:b}:null;
  }
  function opcoesDaPeca(){
    var out=[];
    document.querySelectorAll('variant-picker,.variant-picker,fieldset,.product-form__input,.product-options')
      .forEach(function(bl){
        var rot=(bl.textContent||'').slice(0,160).toLowerCase();
        if(!/size|tama|maat|grö|größ|groesse|ring|talla|taille/.test(rot)) return;
        bl.querySelectorAll('input[type=radio],option').forEach(function(i){
          var v=i.value||i.getAttribute('value'); if(!v||/^\s*$/.test(v)) return;
          var lb=i.closest('label')||document.querySelector('label[for="'+i.id+'"]');
          var ind=i.disabled||i.classList.contains('disabled')||
                  (lb&&/disabled|unavailable|sold/.test(lb.className));
          out.push({raw:v,v:normaliza(v),bruto:String(v).trim().toUpperCase(),
                    amp:amplitude(v),ind:!!ind,el:i,on:!!(i.checked||i.selected)});
        });
      });
    return out;
  }

  function linhasAnel(){
    return [].slice.call(caixa.querySelectorAll('[data-g-table="anel"] tbody tr'))
      .map(function(tr){ return {tr:tr, us:parseFloat(tr.getAttribute('data-size')),
        alt:(tr.getAttribute('data-alt')||'').trim().toUpperCase()}; });
  }
  function esc(t){ return t.replace(/[.*+?^${}()|[\]\\]/g,'\\$&'); }
  function solto(alvo,texto){        // o simbolo aparece como palavra inteira
    if(!alvo) return false;
    return new RegExp('(^|[^0-9A-Z\u00BD])'+esc(alvo)+'([^0-9A-Z\u00BD]|$)').test(texto);
  }
  function cobertas(x,rows){         // indices das linhas que esta opcao cobre
    var out=[],i;
    if(x.amp){ rows.forEach(function(r,i){ if(r.us>=x.amp.a&&r.us<=x.amp.b) out.push(i); });
      if(out.length) return out; }
    rows.forEach(function(r,i){ if(x.v===String(r.us)||x.bruto===r.alt) out.push(i); });
    if(out.length) return out;
    var ix=[];
    rows.forEach(function(r,i){ if(solto(r.alt,x.bruto)) ix.push(i); });
    if(ix.length>=2){ for(i=Math.min.apply(null,ix);i<=Math.max.apply(null,ix);i++) out.push(i); }
    else if(ix.length===1) out.push(ix[0]);
    return out;
  }
  function marcar(){
    var lista=opcoesDaPeca();
    var tAnel=caixa.querySelector('[data-g-table="anel"]');
    if(tAnel&&lista.length){
      var rows=linhasAnel(), tem={}, esco={};
      lista.forEach(function(x){
        cobertas(x,rows).forEach(function(i){ tem[i]=true; if(x.on) esco[i]=true; });
      });
      rows.forEach(function(r,i){
        r.tr.classList.toggle('is-off',!tem[i]);
        r.tr.classList.toggle('is-sel',!!esco[i]);
      });
      caixa.querySelectorAll('[data-g-aneis] .g__anel').forEach(function(d){
        var alvo=d.getAttribute('data-size'), on=false;
        rows.forEach(function(r,i){ if(String(r.us)===alvo&&esco[i]) on=true; });
        d.classList.toggle('is-sel',on);
      });
    }
  }
  document.addEventListener('change',function(e){
    if(e.target.matches('input[type=radio],select')) setTimeout(marcar,70); });

  function podeEscolher(valor){
    var rows=linhasAnel(), alvo=-1;
    rows.forEach(function(r,i){ if(String(r.us)===String(valor)) alvo=i; });
    if(alvo<0) return null;
    var achou=null;
    opcoesDaPeca().forEach(function(x){
      if(achou||x.ind) return;
      if(cobertas(x,rows).indexOf(alvo)>=0) achou=x;
    });
    return achou;
  }
  function mostrarPick(btn,alvo){
    if(!btn) return;
    if(alvo){ btn.hidden=false; btn._alvo=alvo; } else { btn.hidden=true; btn._alvo=null; }
  }
  caixa.addEventListener('click',function(e){
    var b=e.target.closest('[data-g-pick]'); if(!b||!b._alvo) return;
    var x=b._alvo;
    if(x.el.tagName==='OPTION'){ x.el.selected=true;
      x.el.parentNode.dispatchEvent(new Event('change',{bubbles:true})); }
    else { x.el.checked=true; x.el.dispatchEvent(new Event('change',{bubbles:true}));
      var lb=x.el.closest('label')||document.querySelector('label[for="'+x.el.id+'"]');
      if(lb) lb.click(); }
    fechar();
  });

  /* ---------- anéis ---------- */
  var inAnel=caixa.querySelector('#g-mm');
  if(inAnel){
    var modo='circ';
    caixa.querySelectorAll('[data-g-modo]').forEach(function(b){
      b.addEventListener('click',function(){
        modo=b.getAttribute('data-g-modo');
        caixa.querySelectorAll('[data-g-modo]').forEach(function(x){x.classList.toggle('is-on',x===b);});
        calcAnel();
      });
    });
    inAnel.addEventListener('input',calcAnel);
  }
  function calcAnel(){
    var res=caixa.querySelector('[data-g-res]'), resn=caixa.querySelector('[data-g-resn]'),
        resx=caixa.querySelector('[data-g-resx]'), pick=caixa.querySelector('[data-g-pick]');
    var trs=[].slice.call(caixa.querySelectorAll('[data-g-table="anel"] tbody tr'));
    var v=num(inAnel.value);
    var mo=caixa.querySelector('[data-g-modo].is-on');
    var md=mo?mo.getAttribute('data-g-modo'):'circ';
    if(v!==null&&md==='dia') v=v*Math.PI;
    if(v===null){ res.hidden=true; marcar(); return; }
    res.hidden=false;
    var L=trs.map(function(tr){ return {s:tr.getAttribute('data-size'),
      loc:tr.getAttribute('data-local')||('US '+tr.getAttribute('data-size')),
      c:parseFloat(tr.getAttribute('data-mm')),tr:tr,off:tr.classList.contains('is-off')}; });
    var min=L[0].c, max=L[L.length-1].c;
    trs.forEach(function(t){t.classList.remove('is-sel');});
    caixa.querySelectorAll('[data-g-aneis] .g__anel').forEach(function(d){d.classList.remove('is-sel');});
    if(v<min-0.8||v>max+0.8){
      resn.textContent='—';
      resx.textContent=txt('fora','Outside the sizes we carry')+' ('+min.toFixed(1)+'–'+max.toFixed(1)+' mm)';
      mostrarPick(pick,null); return;
    }
    var alvo=null;
    for(var i=0;i<L.length;i++){ if(L[i].c>=v-0.001){ alvo=L[i]; break; } }
    if(!alvo) alvo=L[L.length-1];
    alvo.tr.classList.add('is-sel');
    var cir=caixa.querySelector('[data-g-aneis] .g__anel[data-size="'+alvo.s+'"]');
    if(cir) cir.classList.add('is-sel');
    resn.innerHTML=alvo.loc;
    var notas=[];
    if(Math.abs(alvo.c-v)>0.4) notas.push(txt('entre','Between two sizes — take the larger'));
    if(alvo.off) notas.push(txt('indisp','not available on this piece'));
    resx.textContent=notas.join(' · ');
    mostrarPick(pick, alvo.off?null:podeEscolher(alvo.s));
  }

  /* ---------- pulseiras ---------- */
  var inPulso=caixa.querySelector('#g-pulso');
  if(inPulso) inPulso.addEventListener('input',function(){
    var res=caixa.querySelector('[data-g-pres]'), resn=caixa.querySelector('[data-g-presn]'),
        resx=caixa.querySelector('[data-g-presx]');
    var trs=[].slice.call(caixa.querySelectorAll('[data-g-table="pulso"] tbody tr'));
    var v=num(inPulso.value);
    trs.forEach(function(t){t.classList.remove('is-sel');});
    if(v===null){ res.hidden=true; return; }
    res.hidden=false;
    var achou=null;
    trs.forEach(function(tr){
      var a=parseFloat(tr.getAttribute('data-min')), b=parseFloat(tr.getAttribute('data-max'));
      if(v>=a&&v<b){ tr.classList.add('is-sel'); achou=tr; }
    });
    if(achou){ resn.textContent=achou.cells[0].textContent;
      resx.textContent=txt('p_res','Piece length')+' '+
        (achou.getAttribute('data-peca')||achou.cells[2].textContent); }
    else { resn.textContent='—'; resx.textContent=txt('fora','Outside the sizes we carry'); }
  });

  /* ---------- colares ---------- */
  var colar=caixa.querySelector('[data-g-colar]');
  if(colar){
    function realce(cm){
      caixa.querySelectorAll('[data-g-colar] li').forEach(function(li){
        li.classList.toggle('is-on',li.getAttribute('data-cm')===cm); });
      caixa.querySelectorAll('.g__colar .lin').forEach(function(p){
        p.classList.toggle('is-on',p.getAttribute('data-cm')===cm); });
    }
    colar.addEventListener('mouseover',function(e){
      var li=e.target.closest('li'); if(li) realce(li.getAttribute('data-cm')); });
    colar.addEventListener('click',function(e){
      var li=e.target.closest('li'); if(li) realce(li.getAttribute('data-cm')); });
    colar.addEventListener('mouseleave',function(){ realce(null); });
  }

  /* ---------- anéis a tamanho real ---------- */
  var cal=caixa.querySelector('#g-cal');
  if(cal){
    var CH='gSizePxMm';
    function aplica(px){
      var cart=caixa.querySelector('[data-g-cartao]');
      if(cart) cart.style.width=(85.6*px)+'px';
      caixa.querySelectorAll('[data-g-aneis] .g__anelc').forEach(function(d){
        var mm=parseFloat(d.style.getPropertyValue('--mm'));
        d.style.width=(mm*px)+'px'; d.style.height=(mm*px)+'px';
      });
    }
    var guard=null; try{ guard=localStorage.getItem(CH); }catch(e){}
    if(guard){ cal.value=guard; }
    aplica(parseFloat(cal.value));
    cal.addEventListener('input',function(){
      aplica(parseFloat(cal.value));
      try{ localStorage.setItem(CH,cal.value); }catch(e){}
    });
  }

  /* ---------- chapéus ---------- */
  var inHd=caixa.querySelector('#g-hd');
  if(inHd) inHd.addEventListener('input',function(){
    var res=caixa.querySelector('[data-g-res]'), resn=caixa.querySelector('[data-g-resn]'),
        resx=caixa.querySelector('[data-g-resx]'), pick=caixa.querySelector('[data-g-pick]');
    var marc=caixa.querySelector('[data-g-regm]'), mz=caixa.querySelector('[data-g-regmz]');
    var trs=[].slice.call(caixa.querySelectorAll('[data-g-table="hat"] tbody tr'));
    var v=num(inHd.value);
    trs.forEach(function(t){t.classList.remove('is-sel');});
    if(v===null){ res.hidden=true; if(marc) marc.hidden=true; return; }
    res.hidden=false;
    var MIN=52,MAX=63;
    if(marc&&v>=MIN&&v<=MAX){
      marc.hidden=false;
      var p=4+(v-MIN)/(MAX-MIN)*92;
      marc.style.left='calc('+p+'% - 9px)'; marc.style.width='18px';
      if(mz) mz.textContent=String(v).replace('.',',')+' cm';
    } else if(marc) marc.hidden=true;
    trs.forEach(function(tr){
      var a=parseFloat(tr.getAttribute('data-min')), b=parseFloat(tr.getAttribute('data-max'));
      if(v>=a-0.5&&v<=b+0.49) tr.classList.add('is-sel');
    });
    var todas=opcoesDaPeca(), ops=todas.filter(function(x){return x.amp;});
    if(!ops.length){
      var sel=caixa.querySelector('[data-g-table="hat"] tbody tr.is-sel');
      if(!todas.length){                       // pagina solta: sem ficha de produto
        resn.textContent= sel ? sel.cells[2].textContent : '—';
        resx.textContent= sel ? sel.cells[0].textContent : txt('fora','Outside the sizes we carry');
        mostrarPick(pick,null); return;
      }
      resn.textContent= todas.length===1 ? todas[0].raw : '—';
      resx.textContent= todas.length===1 ? '' : txt('semtam','This item comes in one size.');
      mostrarPick(pick, todas.length===1?todas[0]:null); return;
    }
    var cabe=ops.filter(function(x){ return v>=x.amp.a&&v<=x.amp.b; });
    if(!cabe.length){
      var lo=Math.min.apply(null,ops.map(function(x){return x.amp.a;}));
      var hi=Math.max.apply(null,ops.map(function(x){return x.amp.b;}));
      resn.textContent='—';
      resx.textContent=txt('fora','Outside the sizes we carry')+' ('+lo+'–'+hi+' cm)';
      mostrarPick(pick,null); return;
    }
    cabe.sort(function(a,b){ return b.amp.b-a.amp.b; });   // entre duas, a maior
    var alvo=cabe[0];
    resn.textContent=alvo.raw;
    resx.textContent= cabe.length>1 ? txt('entre','Between two sizes — take the larger') : '';
    mostrarPick(pick, alvo.ind?null:alvo);
  });

  marcar();
})();
